export default __webpack_public_path__ + "maps-examples-clustering-with-images-1200-847ca1b727be2b30d6ca47cd01cce879.webp";